// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1__acbfb7b60d0e0bdeca3f{/*!*/}.ToolsMenu-cls2__dc410f0882713a3df413{display:block;margin:24px 12px 12px;padding:12px 0;border-bottom:1px solid #dddfe2;text-transform:uppercase;font-size:16px;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1__acbfb7b60d0e0bdeca3f",
	"cls2": "ToolsMenu-cls2__dc410f0882713a3df413 ToolsMenu-cls1__acbfb7b60d0e0bdeca3f"
};
export default ___CSS_LOADER_EXPORT___;
